// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"97":"8e834327","237":"c3b549ee","533":"193a8c2a","908":"b6fd4796"}[chunkId] + ".chunk.js";
};